import styled from 'styled-components';
import { LogoutCircleR } from '@styled-icons/remix-line';
import { colors } from 'styles';

export const Container = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
`;

export const Name = styled.h6`
  font-size: 16px;
  color: #030712;
`;

export const Logout = styled.button.attrs({
  type: 'button',
})`
  color: #15803d;
  margin-left: 16px;
  transition: 300ms ease;
  :hover {
    color: #22c55e;
  }
`;

export const LogoutIcon = styled(LogoutCircleR).attrs({ size: 20 })``;
